var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 34.5,
    height: 34.5,
    rx: 17.25,
    fill: "#4C6EF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 34.5,
    height: 34.5,
    rx: 17.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6173 9.07615C16.991 8.92137 17.4211 9.00692 17.7071 9.29292C18.3645 9.9503 19.1876 11.3868 19.5953 13.0233C19.9361 14.3909 20.0214 16.0423 19.3583 17.5898C19.3792 17.5848 19.3967 17.5778 19.4126 17.5714C19.5294 17.5248 19.7389 17.3948 20.047 17.0512C20.3517 16.7114 20.7118 16.209 21.1407 15.4885C21.3038 15.2146 21.5876 15.0349 21.9048 15.0046C22.2221 14.9742 22.5348 15.097 22.7468 15.335C23.3203 15.9789 23.8722 16.957 24.2784 17.9417C24.6825 18.9211 25 20.0459 25 21C25 22.8565 24.2625 24.637 22.9497 25.9498C21.637 27.2625 19.8565 28 18 28C16.1435 28 14.363 27.2625 13.0503 25.9498C11.7375 24.637 11 22.8565 11 21C11 18.9906 11.8681 16.7571 13.2833 15.3027L13.2839 15.3021C13.3162 15.2689 13.3487 15.2356 13.3813 15.2022C14.6073 13.946 16 12.519 16 10C16 9.59557 16.2436 9.23093 16.6173 9.07615ZM17.4701 12.8794C16.8152 14.5552 15.6875 15.7062 14.8698 16.5409C14.8172 16.5945 14.7659 16.6469 14.7161 16.698L14 16L14.7167 16.6974C13.6799 17.763 13 19.4895 13 21C13 22.3261 13.5268 23.5979 14.4645 24.5356C15.4021 25.4732 16.6739 26 18 26C19.3261 26 20.5979 25.4732 21.5355 24.5356C22.4732 23.5979 23 22.3261 23 21C23 20.4221 22.7895 19.5769 22.4296 18.7044C22.2983 18.3861 22.1548 18.0829 22.0075 17.8059C21.8483 18.0198 21.6914 18.2131 21.5361 18.3864C21.1156 18.8553 20.6635 19.2253 20.1547 19.4286C18.9961 19.8916 18.0404 19.3312 17.3626 18.7706C16.9659 18.4425 16.8832 17.8668 17.1714 17.4402C17.9539 16.2821 17.9914 14.8582 17.6547 13.5068C17.6006 13.2899 17.5382 13.0801 17.4701 12.8794Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.72e2900608531c70a65a10414092aae7.svg";
export { ForwardRef as ReactComponent };